(() => {
  const host = document.querySelector('aco-project-cart-sync');
  if (!host || !['autocoloronline.com', 'www.autocoloronline.com', 'auto-color.myshopify.com'].includes(location.hostname) || window.ACOProjectCartSync) return;
  const nativeFetch = window.fetch.bind(window);
  const storageKey = 'aco.activeProject.v2';
  const api = '/apps/aco-projects';
  const select = host.querySelector('select');
  const status = host.querySelector('[data-status]');
  const retry = host.querySelector('[data-retry]');
  const replace = host.querySelector('[data-replace]');
  const stop = host.querySelector('[data-stop]');
  const t = key => host.dataset[key] || key;
  const owned = new Map();
  const revisions = new Map();
  const fingerprints = new Map();
  const conflicts = new Set();
  let active = null, candidate = null, csrf = '', tokenTime = 0;
  let observed = new Map(), removals = false, busy = false, dirty = false;
  let mutationCount = 0, timer, authenticated = false, connected = false;
  let forceEmpty = new Set();
  let connectionGeneration = 0;
  // A restore link must be reviewed before this page saves a new snapshot.
  let restoreHold = location.hash.startsWith('#aco_restore=');
  let restoreRunning = false;
  // Never make the shopper wait on the project service for longer than this before adding to cart.
  const connectGrace = 3000;
  const valid = p => p && typeof p.projectId === 'string' && /^[A-Za-z0-9_-]{1,100}$/.test(p.projectId);
  function tell(key) {
    status.textContent = t(key);
    host.dataset.state = key;
    retry.hidden = !['failed', 'signin'].includes(key);
    replace.hidden = conflicts.size === 0;
  }
  function persist() {
    try { localStorage.setItem(storageKey, JSON.stringify({version: 2, project: active})); } catch {}
  }
  function readCandidate() {
    try {
      if (location.hash.startsWith('#aco_project=')) {
        if (location.hash.length > 8192) return null;
        const p = JSON.parse(decodeURIComponent(location.hash.slice(13)));
        if (p.version !== 1 || !valid(p)) return null;
        history.replaceState(history.state, '', location.pathname + location.search);
        return p;
      }
      const stored = JSON.parse(localStorage.getItem(storageKey) || 'null');
      return stored?.version === 2 && valid(stored.project) ? stored.project : null;
    } catch { return null; }
  }
  function route(input) {
    try {
      const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
      return url.origin === location.origin ? url.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?\/?$/)?.[1] : null;
    } catch { return null; }
  }
  function syncForm(form) {
    if (route(form.action) !== 'add') return;
    for (const [key, value] of [['_aco_project_id', active?.projectId], ['_aco_project_name', active?.projectName]]) {
      const name = `properties[${key}]`;
      const fields = Array.from(form.elements).filter(el => el.name === name);
      if (!value) {
        fields.forEach(el => {
          const changed = el.value !== '' || !el.disabled;
          el.value = ''; el.disabled = true;
          if (changed) {
            el.dispatchEvent(new Event('input', {bubbles: true}));
            el.dispatchEvent(new Event('change', {bubbles: true}));
          }
        });
        continue;
      }
      let input = fields.shift();
      fields.forEach(el => el.remove());
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
      const changed = input.value !== value || input.disabled;
      input.value = value; input.disabled = false;
      if (changed) {
        input.dispatchEvent(new Event('input', {bubbles: true}));
        input.dispatchEvent(new Event('change', {bubbles: true}));
      }
    }
  }
  function syncForms() { document.querySelectorAll('form').forEach(syncForm); }
  function activate(project, save = true) {
    active = project ? {version: 1, projectId: project.id, projectName: project.name} : null;
    candidate = active;
    select.value = active?.projectId || '';
    stop.hidden = !active;
    syncForms();
    if (save) persist();
    tell(active ? 'ready' : 'choose');
    window.dispatchEvent(new CustomEvent('aco:project-change', {detail: {project: active}}));
  }
  function makeOptions(projects) {
    select.replaceChildren();
    const empty = document.createElement('option'); empty.value = ''; empty.textContent = t('choose'); select.append(empty);
    projects.forEach(p => { const option = document.createElement('option'); option.value = p.id; option.textContent = p.name; select.append(option); });
  }
  async function request(path, options = {}) {
    const response = await nativeFetch(path, {credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(12000), ...options});
    let data;
    try { data = await response.json(); } catch { throw new Error('failed'); }
    if (!response.ok || data.ok === false) {
      const error = new Error(data.error || 'failed'); error.code = data.code; error.status = response.status; throw error;
    }
    return data;
  }
  function canon(items) {
    return JSON.stringify(items.map(item => ({...item, properties: Object.fromEntries(Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b)))})));
  }
  function groups(cart) {
    if (!Array.isArray(cart.items)) throw new Error('failed');
    const result = new Map();
    cart.items.forEach(item => {
      const projectId = item.properties?._aco_project_id;
      const project = owned.get(projectId);
      if (!project) return;
      if (item.has_components || item.parent_relationship?.parent) throw new Error('unsupported');
      const properties = Object.fromEntries(Object.entries(item.properties || {}).filter(([,v]) => v != null).map(([k,v]) => [k,String(v)]));
      properties._aco_project_id = projectId; properties._aco_project_name = project.name;
      const saved = {variantId: String(item.variant_id), quantity: item.quantity, title: item.title,
        sellingPlanId: item.selling_plan_allocation?.selling_plan?.id ? String(item.selling_plan_allocation.selling_plan.id) : null, properties};
      if (!result.has(projectId)) result.set(projectId, []);
      result.get(projectId).push(saved);
    });
    return result;
  }
  async function session() {
    const data = await request(api + '/carts');
    if (typeof data.csrfToken !== 'string' || !Array.isArray(data.projects)) throw new Error('failed');
    csrf = data.csrfToken; tokenTime = Date.now();
    return data;
  }
  async function connect() {
    const generation = ++connectionGeneration;
    connected = false; select.disabled = true; tell('checking');
    try {
      const projects = await request(api + '/projects');
      if (!Array.isArray(projects.projects)) throw new Error('failed');
      const saved = await session();
      if (generation !== connectionGeneration) return;
      owned.clear(); projects.projects.forEach(p => owned.set(p.id, p));
      makeOptions(projects.projects);
      saved.projects.forEach(p => {
        if (!revisions.has(p.projectId)) {
          revisions.set(p.projectId, p.latest.revision);
          fingerprints.set(p.projectId, canon(p.latest.items));
        }
      });
      authenticated = true; connected = true; select.disabled = false;
      activate(owned.get(candidate?.projectId));
      schedule();
    } catch (error) {
      if (generation !== connectionGeneration) return;
      authenticated = false; active = null; syncForms();
      select.disabled = true; stop.hidden = !candidate; select.replaceChildren();
      tell(error.code === 'SIGN_IN_REQUIRED' ? 'signin' : 'failed');
    }
  }
  function schedule(explicitRemoval = false) {
    removals ||= explicitRemoval; dirty = true;
    clearTimeout(timer); timer = setTimeout(capture, 600);
  }
  async function capture() {
    if (!connected || !authenticated || busy || restoreHold) return;
    if (mutationCount) { schedule(); return; }
    busy = true; dirty = false;
    const mayRemove = removals; removals = false;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cart = await request(root + 'cart.js');
      const current = groups(cart);
      if (mutationCount) { removals ||= mayRemove; dirty = true; return; }
      const keys = new Set([...current.keys(), ...forceEmpty]);
      if (mayRemove) observed.forEach((_,id) => { keys.add(id); if (!current.has(id)) forceEmpty.add(id); });
      observed = current;
      let savedAny = false;
      for (const id of keys) {
        if (!owned.has(id) || conflicts.has(id)) continue;
        const items = current.get(id) || [];
        const fingerprint = canon(items);
        if (fingerprints.get(id) === fingerprint) { forceEmpty.delete(id); savedAny = true; continue; }
        tell('saving');
        if (Date.now() - tokenTime > 12 * 60 * 1000) await session();
        let result;
        try {
          result = await request(api + '/carts', {method: 'POST', headers: {'Content-Type': 'application/json', 'X-ACO-CSRF': csrf},
            body: JSON.stringify({projectId: id, expectedRevision: revisions.get(id) ?? null, items})});
        } catch (error) {
          if (error.code === 'CART_CHANGED') { conflicts.add(id); tell('conflict'); continue; }
          if (error.code === 'INVALID_SAVE_SESSION' || error.code === 'SIGN_IN_REQUIRED') {
            connected = false; authenticated = false; active = null; syncForms();
          }
          throw error;
        }
        if (!result.saved || typeof result.revision !== 'string') throw new Error('failed');
        revisions.set(id, result.revision); fingerprints.set(id, fingerprint); forceEmpty.delete(id); savedAny = true;
      }
      tell(conflicts.size ? 'conflict' : savedAny ? 'saved' : active ? 'ready' : 'choose');
    } catch (error) { removals ||= mayRemove; tell(error.code === 'SIGN_IN_REQUIRED' ? 'signin' : error.message === 'unsupported' ? 'unsupported' : 'failed'); }
    finally { busy = false; if (dirty) schedule(); }
  }
  function tagFields(data, project) {
    for (const key of ['_aco_project_id', '_aco_project_name']) data.delete(`properties[${key}]`);
    if (project) {
      data.set('properties[_aco_project_id]', project.projectId);
      data.set('properties[_aco_project_name]', project.projectName);
    }
    return data;
  }
  function tagObject(item, project) {
    if (!item || typeof item !== 'object' || Array.isArray(item)) throw new Error('failed');
    const properties = {...item.properties};
    delete properties._aco_project_id; delete properties._aco_project_name;
    if (project) { properties._aco_project_id = project.projectId; properties._aco_project_name = project.projectName; }
    return {...item, properties};
  }
  async function taggedRequest(input, init, project) {
    const req = new Request(input, init);
    const contentType = req.headers.get('Content-Type') || '';
    let body, headers = new Headers(req.headers);
    if (contentType.includes('application/json')) {
      const data = await req.clone().json();
      body = JSON.stringify(Array.isArray(data.items) ? {...data, items: data.items.map(item => tagObject(item, project))} : tagObject(data, project));
    } else if (contentType.includes('multipart/form-data') || contentType.includes('application/x-www-form-urlencoded')) {
      const data = await req.clone().formData();
      if ([...data.keys()].some(k => k.startsWith('items['))) throw new Error('unsupported');
      body = tagFields(data, project); headers.delete('Content-Type');
    } else { if (project) throw new Error('unsupported'); return req; }
    return new Request(req.url, {method: req.method, body, headers,
      credentials: req.credentials, mode: req.mode, cache: req.cache,
      redirect: req.redirect, referrer: req.referrer, referrerPolicy: req.referrerPolicy,
      integrity: req.integrity, keepalive: req.keepalive, signal: req.signal});
  }
  candidate = readCandidate();
  host.hidden = false;
  const initial = connect();
  // Resolves when the project service has answered, or after a short grace period — whichever comes first.
  const ready = () => Promise.race([initial, new Promise(resolve => setTimeout(resolve, connectGrace))]);
  window.fetch = async (input, init) => {
    const action = route(input);
    const method = String(init?.method || (input instanceof Request ? input.method : 'GET')).toUpperCase();
    if (!action || method !== 'POST') return nativeFetch(input, init);
    mutationCount++;
    try {
      let response;
      if (action === 'add') {
        await ready();
        // If the project service is unavailable or the shopper is signed out, add to the cart anyway — just without a project tag.
        const project = connected ? active : null;
        const absolute = typeof input === 'string' ? new URL(input, location.href).href : input;
        let tagged;
        try { tagged = await taggedRequest(absolute, init, project); }
        catch { tagged = new Request(absolute, init); }
        response = await nativeFetch(tagged);
      } else response = await nativeFetch(input, init);
      if (response.ok && connected) schedule(action !== 'add');
      return response;
    } finally { mutationCount--; }
  };
  document.addEventListener('formdata', event => {
    if (route(event.target.action) === 'add') tagFields(event.formData, connected ? active : null);
  }, true);
  document.addEventListener('submit', event => {
    if (route(event.target.action) !== 'add') return;
    syncForm(event.target);
  }, true);
  for (const type of ['pointerdown', 'click', 'keydown']) {
    document.addEventListener(type, event => {
      if (type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
      const form = event.target instanceof Element ? event.target.closest('form') : null;
      if (!form || route(form.action) !== 'add') return;
      syncForm(form);
    }, true);
  }
  let formTimer;
  new MutationObserver(records => {
    if (!records.some(r => r.addedNodes.length)) return;
    clearTimeout(formTimer); formTimer = setTimeout(syncForms, 50);
  }).observe(document.body, {childList: true, subtree: true});
  select.addEventListener('change', () => { activate(owned.get(select.value)); schedule(); });
  stop.addEventListener('click', () => activate(null));
  retry.addEventListener('click', () => { if (!busy) connect(); });
  replace.addEventListener('click', async () => {
    if (busy) return;
    replace.disabled = true;
    try {
      const data = await session();
      for (const id of conflicts) {
        const latest = data.projects.find(p => p.projectId === id)?.latest;
        revisions.set(id, latest?.revision ?? null); fingerprints.delete(id); forceEmpty.add(id);
      }
      conflicts.clear(); schedule();
    } catch { tell('failed'); }
    finally { replace.disabled = false; }
  });
  window.addEventListener('hashchange', () => { candidate = readCandidate(); connect(); });
  window.addEventListener('storage', event => {
    if (event.key !== storageKey) return;
    candidate = readCandidate();
    if (connected) activate(owned.get(candidate?.projectId), false);
  });
  window.addEventListener('pageshow', () => { if (connected) schedule(); });
  window.addEventListener('focus', () => { if (connected) schedule(); });
  setInterval(() => { if (document.visibilityState === 'visible' && connected) schedule(); }, 15000);
  async function loadRestore(reference) {
    restoreHold = true;
    await initial;
    if (busy || mutationCount) throw new Error('failed');
    const projects = await request(api + '/projects');
    const project = projects.projects?.find(p => p.id === reference.projectId);
    if (!project) throw new Error('missing');
    const data = await session();
    const entry = data.projects.find(p => p.projectId === project.id);
    const saved = entry && [entry.latest, ...entry.history].find(s => s.revision === reference.revision);
    if (!saved || !Array.isArray(saved.items) || saved.items.length > 50 || saved.items.some(item =>
      item.properties?._aco_project_id !== project.id || !/^[1-9]\d{0,19}$/.test(item.variantId) ||
      !Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > 9999)) throw new Error('missing');
    owned.set(project.id, project);
    revisions.set(project.id, entry.latest.revision);
    fingerprints.set(project.id, canon(entry.latest.items));
    return {project, saved};
  }
  async function restoreItems(snapshot, run, progress) {
    if (restoreRunning || mutationCount || busy) throw new Error('failed');
    restoreRunning = true; mutationCount++;
    try {
      activate(snapshot.project);
      const root = window.Shopify?.routes?.root || '/';
      const readCart = () => request(root + 'cart.js');
      const addItem = async (item, quantity) => {
        const response = await nativeFetch(root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({items: [{id: item.variantId, quantity,
            properties: {...item.properties, _aco_project_id: snapshot.project.id, _aco_project_name: snapshot.project.name},
            ...(item.sellingPlanId ? {selling_plan: item.sellingPlanId} : {})}]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : t('failed'));
      };
      return await run(snapshot.saved.items, readCart, addItem, progress);
    } finally { mutationCount--; restoreRunning = false; }
  }
  window.ACOProjectCartSync = Object.freeze({getActiveProject: () => active ? {...active} : null,
    refresh: () => schedule(), stop: () => activate(null), loadRestore, restoreItems,
    finishRestore: () => { if (!restoreRunning) restoreHold = false; }
  });
  window.ACOProjectShopping = window.ACOProjectCartSync;
})();
